/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';
import HomeHeader from './components/HomeHeader';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const updateHeader = header =>
    onSerialize({
      ...content,
      header,
    });

  return (
    <div>
      <HomeHeader header={content.header} onHeaderUpdated={updateHeader} />
      <Message
        icon="newspaper"
        header="Actualités"
        content={`Les actualités sont gérées via le module dédié de gestion d'actualités`}
      />
    </div>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/home/Edit.js